module.exports = __webpack_public_path__ + "img/48.4884b3fd.jpg";